import React from "react";
import { TestimonialBlock } from "../components/testimonial";
import { Link } from "react-router-dom";
import FaceJeff from "@/assets/images/markus-r.png";
import Hero from "@/assets/images/startup-hero.jpg";

/* Container */
const Container: React.FC<React.PropsWithChildren<{ className?: string }>> = ({
  className = "",
  children,
}) => (
  <div className={`mx-auto w-full max-w-6xl px-4 sm:px-6 lg:px-8 ${className}`}>
    {children}
  </div>
);

export default function ServicesStartupsPage() {
  return (
    <section className="py-14 text-white">
      <Container>
        {/* Back link */}
        <Link
          to="/services"
          className="inline-flex items-center text-sm text-white/60 hover:text-white mb-6 transition"
        >
          ← Services
        </Link>

        {/* Header */}
        <div className="mb-12">
          <h2 className="font-display text-4xl md:text-7xl mb-6">
            We help founders turn ideas into real products
          </h2>
          <p className="text-lg md:text-2xl leading-7 md:leading-9 text-white/60">
            We help early-stage teams to design and build products — as
            operators, advisors or investors — depending on what moves the
            product forward. From first clickable prototype to MVP launch and
            early traction, we bring hands-on product, design and engineering
            support.
          </p>
        </div>

        {/* Meta section */}
        <div className="flex flex-col md:flex-row gap-10 md:gap-40 text-white/60 mb-10">
          {/* Left column */}
          <div className="space-y-6">
            <div>
              <h3 className="font-semibold text-white">
                Ventures & collaborations
              </h3>
              <ul className="space-y-1">
                <li>
                  <a href="https://pinshirt.me" target="_blank" rel="noopener">
                    PinShirt
                  </a>
                </li>
                <li>ComFoo</li>
              </ul>
            </div>
          </div>

          {/* Right column */}
          <div className="space-y-6">
            <div>
              <h3 className="font-semibold text-white">What we do</h3>
              <ul className="space-y-1">
                <li>Product strategy & discovery</li>
                <li>UX/UI design & prototyping</li>
                <li>MVP & early product development</li>
                <li>Brand & go-to-market support</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Image */}
        <img src={Hero} alt="Startup collaboration" className="mb-10" />

        {/* Body copy */}
        <div className="mb-8 text-lg md:text-2xl leading-7 md:leading-9 leading-relaxed w-full md:w-3/4 text-white/80">
          <p>
            We’re not just advisors — we&apos;re operators. We run our own
            products, like{" "}
            <a
              href="https://pinshirt.me/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white font-bold underline"
            >
              PinShirt
            </a>
            , and bring
            that hands-on startup experience into every collaboration.
          </p>
          <p className="mt-4">
            If you have an idea and need help making it real — from first
            clickable prototype to MVP launch and early traction — we can step
            in with design, development, product thinking and brand strategy.
          </p>
          <p className="mt-4">
            We love working with founders who move fast, value simplicity over
            slides, and want a team that can help build both product and
            momentum.
          </p>
        </div>

        {/* Testimonial 
        <TestimonialBlock
          quote="BoldBrave understand what it means to build early-stage products. They move fast, think like founders, and ship with care and conviction."
          author="Magnus Frennmark"
          role="CEO Fitness24Seven"
          avatar={FaceJeff}
        />
        */}
      </Container>
    </section>
  );
}
